import { getTopAreaHeight } from '../vue-app/utils/utils.js';

class FixedHeader {
  constructor(element) {
    this.element = element;
    this.componentMounted = false;
    this.activeElement = null;
    this.elements = [];
    this.isMobileView = false;
    this.showExpandButton = false;
    this.topAreaHeight = 0;
    this.showDesktopMenu = false;
    this.showMobileMenu = false;

    this.activeElementBtn = element.querySelector('.activeElement');
    this.mobileToggleBtn = element.querySelector('[data-action="toggleMobileMenu"]');
    this.desktopToggleBtn = element.querySelector('[data-action="toggleDesktopMenu"]');
    this.expandButton = element.querySelector('.expandBtn');
    this.navCollapse = element.querySelector('.navbar-collapse');
    this.dropdownMenu = element.querySelector('.dropdown-menu');

    this.init();
  }

  init() {
    this.componentMounted = true;

    this.bindEvents();

    setTimeout(() => {
      this.initializeNavItems();
      this.handle();
      setTimeout(() => this.handle(), 100);
    }, 1);
  }

  initializeNavItems() {
    let right = 2;
    const navItems = this.element.querySelectorAll('.v-nav-item');

    navItems.forEach((item, i) => {
      right += item.scrollWidth;
      this.elements.push({
        element: item,
        right: right,
        fits: true,
        index: i,
        anchorId: item.getAttribute('data-anchor'),
        isActiveElement: false
      });
    });
  }

  bindEvents() {
    this.element.addEventListener('click', (e) => {
      const action = e.target.getAttribute('data-action') || e.target.closest('[data-action]')?.getAttribute('data-action');

      if (action === 'scrollToView') {
        e.preventDefault();
        const target = e.target.getAttribute('data-target') || e.target.closest('[data-target]')?.getAttribute('data-target');
        this.scrollToView(target, e);
      } else if (action === 'toggleMobileMenu') {
        e.preventDefault();
        this.toggleMobileMenu();
      } else if (action === 'toggleDesktopMenu') {
        e.preventDefault();
        this.toggleDesktopMenu(e);
      }
    });

    window.addEventListener('resize', (e) => this.handle(e));
    window.addEventListener('scroll', (e) => this.handle(e));
    document.addEventListener('click', (e) => this.clickOutListener(e));
  }

  scrollToView(elementId, e) {
    this.setMobileMenuState(false);
    this.setDesktopMenuState(false);

    const elem = document.getElementById(elementId);
    if (elem) {
      elem.style.position = 'relative';
      elem.style.top = this.topAreaHeight * -1 + 'px';
      elem.scrollIntoView({ behavior: 'smooth', block: 'start' });
      elem.style.top = 0;
    }
  }

  toggleDesktopMenu(e) {
    this.setDesktopMenuState(!this.showDesktopMenu);
  }

  toggleMobileMenu() {
    this.setMobileMenuState(this.isMobileView && !this.showMobileMenu);
  }

  setMobileMenuState(show) {
    this.showMobileMenu = show;
    this.mobileToggleBtn.classList.toggle('menu-shown', show);
    this.mobileToggleBtn.setAttribute('aria-expanded', show ? 'true' : 'false');
    this.navCollapse.classList.toggle('show', show);
  }

  setDesktopMenuState(show) {
    this.showDesktopMenu = show;
    this.desktopToggleBtn.setAttribute('aria-expanded', show ? 'true' : 'false');
    this.dropdownMenu.classList.toggle('show', show);
  }

  getAvailableAreaForItems() {
    const standardModularPage = document.getElementsByClassName('standard-modular-page')[0];
    if (standardModularPage && this.expandButton && this.expandButton.parentNode) {
      return standardModularPage.clientWidth - this.expandButton.parentNode.offsetWidth;
    }
    return 0;
  }

  isElementActive(id) {
    const elem = document.getElementById(id);
    if (elem && elem.parentNode) {
      return (elem.getBoundingClientRect().bottom + elem.parentNode.offsetHeight + 5 > this.topAreaHeight);
    }
    return false;
  }

  handle(e) {
    if (!e || e.type !== 'scroll') {
      this.topAreaHeight = getTopAreaHeight();
    }
    const availableArea = this.getAvailableAreaForItems();

    this.isMobileView = window.innerWidth < 1200;
    let found = false;

    if (this.elements && this.elements.length > 0) {
      this.elements.forEach((item, i) => {
        item.fits = this.isMobileView ? true : (this.elements[i].right < availableArea);
        item.isActiveElement = false;
        if (!found && item.anchorId && this.isElementActive(item.anchorId)) {
          found = true;
          item.isActiveElement = true;
          this.activeElement = item.element;
        }

        item.element.classList.toggle('hide', !item.fits);
        item.element.classList.toggle('active', item.isActiveElement);

        const dropdownItem = this.dropdownMenu.querySelector(`[data-index="${i}"]`);
        if (dropdownItem) {
          dropdownItem.classList.toggle('hide', item.fits);
          dropdownItem.classList.toggle('active', item.isActiveElement);
        }
      });

      this.showExpandButton = this.elements.some((v) => !v.fits);
      this.navCollapse.classList.toggle('hide-dropdown', !this.showExpandButton);

      if (this.activeElementBtn) {
        this.activeElementBtn.textContent = this.activeElement.innerText;
        let anchorId = this.activeElement.getAttribute('data-anchor');
        if (anchorId) {
          this.activeElementBtn.addEventListener('click', (e) => {
            this.scrollToView(anchorId);
          });
        }
      }
    }
  }

  clickOutListener(e) {
    if (this.mobileToggleBtn &&
      e.target !== this.mobileToggleBtn &&
      !this.mobileToggleBtn.contains(e.target)) {
      this.setMobileMenuState(false);
    }
    else if (this.expandButton &&
      e.target !== this.expandButton &&
      !this.expandButton.contains(e.target)) {
      this.setDesktopMenuState(false);
    }
  }

  destroy() {
    window.removeEventListener('resize', this.handle);
    window.removeEventListener('scroll', this.handle);
    document.removeEventListener('click', this.clickOutListener);
  }
}

const initFixedHeader = () => {
    new FixedHeader(document.querySelector('.fixed-header'));
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFixedHeader);
} else {
  initFixedHeader();
}

export default FixedHeader;